import { IconProps } from "@/types/types";

export default function Home({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.18459 10.9998C1.7165 10.9998 1.50505 10.4141 1.86517 10.1151L10.7221 2.76063C11.4628 2.14555 12.5367 2.14555 13.2774 2.76063L22.1343 10.1151C22.4944 10.4141 22.283 10.9998 21.8149 10.9998H19.9997V19.9998C19.9997 20.552 19.552 20.9998 18.9997 20.9998H14.9997C14.4475 20.9998 13.9997 20.552 13.9997 19.9998V14.9998C13.9997 14.4475 13.552 13.9998 12.9997 13.9998H10.9997C10.4475 13.9998 9.99972 14.4475 9.99972 14.9998V19.9998C9.99972 20.552 9.55204 20.9998 8.99976 20.9998H4.99976C4.44747 20.9998 3.99976 20.552 3.99976 19.9998V10.9998H2.18459Z" fill="currentColor" />
        </svg>



    )
}

